/** When the user wants to create an in-editor link to another section of their content,
 *  these objects render the previews shown in the dropdown for our images and galleries.
 *  See also: https://ricos.js.org/docs/plugins_api/LinkPlugin
 * */ import React from 'react';
import i18next from 'i18next';
import EditorDumbo from '../../DeviationViews/Dumbo';
import shortenNumber from '@wix/da-ds/pkg/utils/shortenNumber';
const PREVIEW_IMAGE_WIDTH = 50;
// slightly shorter - without this upper and lower borders in plugin don't work
const PREVIEW_IMAGE_HEIGHT = 48;
export const getAnchorBlockPreview = ({ type, data })=>{
    switch(type){
        case 'wix-draft-plugin-image':
            return getImageAnchorBlockPreview(data);
        case 'wix-draft-plugin-gallery':
            return getGalleryAnchorBlockPreview(data);
        default:
            // This allows the block previews built into the plugin to be used for other types
            return undefined;
    }
};
/** Returns a thumbnail and data for a single deviation */ export const getImageAnchorBlockPreview = (data)=>{
    const deviation = data.data;
    return deviation ? {
        thumbnail: /*#__PURE__*/ React.createElement(EditorDumbo, {
            deviation: deviation,
            width: PREVIEW_IMAGE_WIDTH,
            height: PREVIEW_IMAGE_HEIGHT
        }),
        type: i18next.t('common.deviation'),
        content: deviation.title
    } : undefined;
};
/** Chooses the first image of the gallery and provides a count of deviations */ export const getGalleryAnchorBlockPreview = (data)=>{
    const deviations = data.data;
    const deviationCount = deviations === null || deviations === void 0 ? void 0 : deviations.length;
    return deviationCount ? {
        thumbnail: /*#__PURE__*/ React.createElement(EditorDumbo, {
            deviation: deviations[0],
            width: PREVIEW_IMAGE_WIDTH,
            height: PREVIEW_IMAGE_HEIGHT
        }),
        type: i18next.t('common.gallery'),
        content: i18next.t('common.deviationCount', {
            formattedCount: shortenNumber(deviationCount),
            count: deviationCount
        })
    } : undefined;
};

//# sourceMappingURL=AnchorBlockPreview.js.map